<script lang="ts" setup>
import { computed, onMounted, ref, useTemplateRef } from '#imports';
import type { CodeMsgVO } from '@core/types/im';
import { watchElementVisible } from '../../composables/watch-element-visible';
import ImMsgBase from './ImMsgBase.vue';

interface Props {
  msg: CodeMsgVO;
}

const { msg } = defineProps<Props>();
const codeRef = useTemplateRef('code');

const emit = defineEmits(['retry', 'read']);

function handleRetry() {
  emit('retry');
}
function handleRead() {
  emit('read');
}

function handleOpen() {
  window.open(msg.msgBody.codeMsg.url);
}

onMounted(() => {
  if (!msg.isMine && msg.readStatus === 0) {
    watchElementVisible(codeRef, handleRead);
  }
});
</script>

<template>
  <ImMsgBase
    :recall="msg.msgBody.recall"
    :avatar="msg.avatar"
    :show-datetime="msg.showDatetime"
    :time="msg.msgTime"
    :placement="msg.placement"
    :loading="msg.loading"
    :error="msg.error"
    @retry="handleRetry"
  >
    <div
      ref="code"
      class="flex cursor-pointer items-center justify-start"
      @click="handleOpen"
    >
      <div class="flex-center h-[44px] w-[70px] rounded bg-white p-[7px]">
        <img
          :src="msg.msgBody.codeMsg.logo"
          alt="logo"
          class="max-h-full max-w-full"
        />
      </div>
      <div class="ml-2.5 text-sm leading-[22px]">
        <div class="text-font1">{{ msg.msgBody.codeMsg.title }}</div>
        <div class="text-info">查看代码</div>
      </div>
    </div>
  </ImMsgBase>
</template>

<style scoped></style>
